const updateLookupsIsLoading = (state, action) => {
  const { isLoadingItems } = action.payload;
  return {
    ...state,
    isLoadingItems,
  };
};

const updateLookups = (state, action) => {
  const { lookupsData } = action.payload;
  return { ...state, lookups: lookupsData };
};

const updateLookupsPagination = (state, action) => {
  const { size, skip, totalItemCount } = action.payload;
  return {
    ...state,
    pagination: {
      ...state.pagination,
      lookups: {
        ...state.pagination.lookups,
        totalItemCount,
        skip,
        size,
      },
    },
  };
};

const updateLookupsTableSorting = (state, action) => {
  const { sortBy, sortDirection } = action.payload;
  return {
    ...state,
    sorting: {
      sortBy,
      sortDirection,
    },
  };
};

const updateLookupsModalData = (state, action) => {
  const { lookupsModalData } = action.payload;
  return {
    ...state,
    lookupsModalData,
  };
};

const updateIsTableView = (state, action) => {
  const { isTableView } = action.payload;
  return {
    ...state,
    isTableView,
  };
};

const updateLookupToSearch = (state, action) => {
  const { lookupToSearch } = action.payload;
  return {
    ...state,
    filters: {
      ...state.filters,
      lookupToSearch,
    },
  };
};

const updateActiveLookupId = (state, action) => {
  const { activeLookupId } = action.payload;
  return {
    ...state,
    activeLookupData: {
      ...state.activeLookupData,
      activeLookupId,
    },
  };
};
const updateActiveLookupDisplayName = (state, action) => {
  const { activeLookupDisplayName } = action.payload;
  return {
    ...state,
    activeLookupData: {
      ...state.activeLookupData,
      activeLookupDisplayName,
    },
  };
};

const updateActiveLookupData = (state, action) => {
  const { columns, rows, lookupName, totalRows } = action.payload;
  return {
    ...state,
    activeLookupData: {
      ...state.activeLookupData,
      activeLookupColumns: columns,
      activeLookupRows: rows,
      activeLookupDisplayName: lookupName || '',
      activeLookupTotalRows: totalRows,
    },
  };
};

const updateIsLoadingSingleLookup = (state, action) => {
  const { isLoadingSingleLookup } = action.payload;
  return {
    ...state,
    isLoadingSingleLookup,
  };
};

const updateLookupFileToTest = (state, action) => {
  const { lookupFileToTest } = action.payload;
  return {
    ...state,
    getLookupResult: {
      ...state.getLookupResult,
      lookupFileToTest: {
        ...state.getLookupResult.lookupFileToTest,
        lookupFileToTest,
      },
    },
  };
};

const updateLookupFileToTestColumns = (state, action) => {
  const { lookupFileToTestColumns } = action.payload;
  return {
    ...state,
    getLookupResult: {
      ...state.getLookupResult,
      lookupColumnToTest: {
        ...state.getLookupResult.lookupColumnToTest,
        lookupColumnsToTest: lookupFileToTestColumns,
      },
    },
  };
};

const updateLookupValueToTestFor = (state, action) => {
  const { lookupValueToTestFor } = action.payload;
  return {
    ...state,
    getLookupResult: {
      ...state.getLookupResult,
      lookupValueToTestFor,
    },
  };
};

const updateLookupFileColumnToTest = (state, action) => {
  const { lookupColumnToTest } = action.payload;
  return {
    ...state,
    getLookupResult: {
      ...state.getLookupResult,
      lookupColumnToTest: {
        ...state.getLookupResult.lookupColumnToTest,
        lookupColumnToTest,
      },
    },
  };
};

const updateLookupTestResultRows = (state, action) => {
  const { lookupTestResultRows } = action.payload;
  return {
    ...state,
    getLookupResult: {
      ...state.getLookupResult,
      lookupTestResult: {
        ...state.getLookupResult.lookupTestResult,
        lookupTestResultRows,
      },
    },
  };
};

const updateIsLoadingLookupTestResult = (state, action) => {
  const { isLoadingLookupTestResult } = action.payload;
  return {
    ...state,
    getLookupResult: {
      ...state.getLookupResult,
      lookupTestResult: {
        ...state.getLookupResult.lookupTestResult,
        isLoadingLookupTestResult,
      },
    },
  };
};

const updateHasLoadedLookupTestResult = (state, action) => {
  const { hasLoadedLookupTestResult } = action.payload;
  return {
    ...state,
    getLookupResult: {
      ...state.getLookupResult,
      lookupTestResult: {
        ...state.getLookupResult.lookupTestResult,
        hasLoadedLookupTestResult,
      },
    },
  };
};

const updateActiveLookupPaginationSkip = (state, action) => {
  const { skip } = action.payload;
  return {
    ...state,
    activeLookupData: {
      ...state.activeLookupData,
      activeLookupPagination: {
        ...state.activeLookupData.activeLookupPagination,
        skip,
      },
    },
  };
};

const appendActiveLookupRows = (state, action) => {
  const { activeLookupRows } = action.payload;
  return {
    ...state,
    activeLookupData: {
      ...state.activeLookupData,
      activeLookupRows: [
        ...state.activeLookupData.activeLookupRows,
        ...activeLookupRows,
      ],
    },
  };
};

export const mainReducers = {
  LOOKUPS_UPDATE_LOOKUPS_IS_LOADING: updateLookupsIsLoading,
  LOOKUPS_UPDATE_LOOKUPS: updateLookups,
  LOOKUPS_UPDATE_LOOKUPS_PAGINATION: updateLookupsPagination,
  LOOKUPS_UPDATE_LOOKUPS_TABLE_SORTING: updateLookupsTableSorting,
  LOOKUPS_UPDATE_LOOKUPS_MODAL_DATA: updateLookupsModalData,
  LOOKUPS_UPDATE_IS_TABLE_VIEW: updateIsTableView,
  LOOKUPS_UPDATE_LOOKUP_TO_SEARCH: updateLookupToSearch,
  LOOKUPS_UPDATE_ACTIVE_LOOKUP_ID: updateActiveLookupId,
  LOOKUPS_UPDATE_ACTIVE_LOOKUP_DATA: updateActiveLookupData,
  LOOKUPS_UPDATE_IS_LOADING_SINGLE_LOOKUP: updateIsLoadingSingleLookup,
  LOOKUPS_UPDATE_ACTIVE_LOOKUP_DISPLAY_NAME: updateActiveLookupDisplayName,
  LOOKUPS_UPDATE_LOOKUP_FILE_TO_TEST: updateLookupFileToTest,
  LOOKUPS_UPDATE_LOOKUPS_FILE_TO_TEST_COLUMNS: updateLookupFileToTestColumns,
  LOOKUPS_UPDATE_LOOKUP_VALUE_TO_TEST_FOR: updateLookupValueToTestFor,
  LOOKUPS_UPDATE_LOOKUP_FILE_COLUMN_TO_TEST: updateLookupFileColumnToTest,
  LOOKUPS_UPDATE_LOOKUP_TEST_RESULTS_COLUMNS: updateLookupTestResultRows,
  LOOKUPS_UPDATE_IS_LOADING_LOOKUP_TEST_RESULT: updateIsLoadingLookupTestResult,
  LOOKUPS_UPDATE_HAS_LOADED_LOOKUP_TEST_RESULT: updateHasLoadedLookupTestResult,
  LOOKUPS_UPDATE_ACTIVE_LOOKUP_PAGINATION_SKIP:
    updateActiveLookupPaginationSkip,
  LOOKUPS_APPEND_ACTIVE_LOOKUP_ROWS: appendActiveLookupRows,
};

export default mainReducers;
